import { ManageMyTeamCTA } from "./ctas";
export var ManageTeamsIA = function ManageTeamsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return MANAGE_YOUR_TEAM(strictLocalize);
    },
    getDescription: function getDescription() {
      return [MEMBERS_OF_YOUR_TEAM(strictLocalize), TO_CREATE_OR_MANAGE_YOUR_TEAM(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return ManageMyTeamCTA(strictLocalize);
};
var MANAGE_YOUR_TEAM = function MANAGE_YOUR_TEAM(strictLocalize) {
  return strictLocalize({
    id: "NjuaWu",
    defaultMessage: [{
      "type": 0,
      "value": "Je team beheren"
    }]
  });
};
var MEMBERS_OF_YOUR_TEAM = function MEMBERS_OF_YOUR_TEAM(strictLocalize) {
  return strictLocalize({
    id: "+yGnWb",
    defaultMessage: [{
      "type": 0,
      "value": "Leden van je team kunnen hun eigen inloggegevens hebben voor je Faire-account. Je kunt dan efficiënter samenwerken, de communicatie van je bestellingen efficiënter laten verlopen en de rollen en rechten van teamleden beheren."
    }]
  });
};
var TO_CREATE_OR_MANAGE_YOUR_TEAM = function TO_CREATE_OR_MANAGE_YOUR_TEAM(strictLocalize) {
  return strictLocalize({
    id: "FHtHSw",
    defaultMessage: [{
      "type": 0,
      "value": "Als je je team wilt aanmaken of beheren, machtigingen en het eigendom van je account wilt beheren, klik dan op de onderstaande knop of lees het Helpcentrum-artikel voor meer informatie. Je kunt contact met ons opnemen als je meer hulp nodig hebt."
    }]
  });
};